import { render, staticRenderFns } from "./Targibot.vue?vue&type=template&id=068230ae&scoped=true"
import script from "./Targibot.vue?vue&type=script&lang=js"
export * from "./Targibot.vue?vue&type=script&lang=js"
import style0 from "./Targibot.vue?vue&type=style&index=0&id=068230ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068230ae",
  null
  
)

export default component.exports